<lib-profile-dropdown-menu-header />

@for (item of profileMenuItems(); track item.slug) {
  <lib-profile-dropdown-menu-item
    [item]="item"
    (action)="selectMenuItem($event)" />
}
